import { render } from "./PhotographFooter.vue?vue&type=template&id=34c7d3b4&scoped=true"
import script from "./PhotographFooter.vue?vue&type=script&lang=js"
export * from "./PhotographFooter.vue?vue&type=script&lang=js"

import "./PhotographFooter.vue?vue&type=style&index=0&id=34c7d3b4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c7d3b4"]])

export default __exports__